import React from 'react';
import { Route } from 'react-router';
import ConditionalRendererPrepaidDealListContainer from 'split-chunk-loader?lazy!../Promotion/ConditionalRendererPrepaidDealListContainer';
import ConditionalRendererPromotionContainer from 'split-chunk-loader?lazy!../Promotion/ConditionalRendererPromotionContainer';
import CouponCodeListContainer from 'split-chunk-loader?lazy!../Promotion/CouponCodeListContainer';
import BulkPrepaidListContainer from 'split-chunk-loader?lazy!../Promotion/BulkPrepaidListContainer';
import PackageListContainer from 'split-chunk-loader?lazy!../Promotion/PackageListContainer';
import { lazify } from '../Common/Helper';

const metadata = {
  title: 'Promotions, Vouchers, Promo Codes, Online Deals',
  metaDescription: '{storeName} brings you the best promotions / deals on photo books, canvas prints, photo frames, flush mount albums. Grab the 100% working latest vouchers & promo codes for the week.',
};

const PromotionsRoute = (
  <Route label="Promotions" helmet={metadata} path="promotions" component={lazify(ConditionalRendererPromotionContainer)}>
    <Route label="Prepaid" helmet={metadata} path="prepaid" component={lazify(ConditionalRendererPrepaidDealListContainer)}/>
    <Route label="Coupon" helmet={metadata} path="coupon" component={lazify(CouponCodeListContainer)}/>
    <Route label="Bulk" helmet={metadata} path="bulk" component={lazify(BulkPrepaidListContainer)}/>
    <Route label="Package" helmet={metadata} path="package" component={lazify(PackageListContainer)}/>
  </Route>
);

export default PromotionsRoute;



// WEBPACK FOOTER //
// ./src/Routes/Promotions.js